import Agent from 'infrastructure/agent';

const getObjectives = () => Agent.get('/objective');

const objectiveService = {
  getObjectives,
};

export default objectiveService;
